import React, {useRef} from 'react'
import { Link } from 'react-router-dom'
import styles from '../componentsStyles/Home.module.css'
import {BsPc, BsArrowRight} from 'react-icons/bs'
import { TbWorldWww, TbDeviceDesktop} from 'react-icons/tb'
import {SiMongodb, SiExpress, SiNodedotjs, SiReact, SiNextdotjs, SiPostgresql, SiPrisma} from 'react-icons/si';
import {RiDrizzleLine} from 'react-icons/ri'

import { useScroll, useTransform, motion } from 'framer-motion'

const HomeSlider = () => {

    const containerRef = useRef();

    const {scrollYProgress} = useScroll({
        target: containerRef,
        offset:["start end", "end end"]
    })

    const opacityOut = useTransform(scrollYProgress,
        [0.70,0.8],
        [1, 0]
    )

    const opacityIn = useTransform(scrollYProgress,
    [0.8,0.9],
    [0, 1]
    )
    

    const x =useTransform(scrollYProgress,
    [0.7, 0.8],
    ["0%", "-10%"]    
    )



  return (




    <div className={styles.homeSlider}>

        <div className={styles.homeHeight} ref={containerRef}>
            <div className={styles.homeSticky}>

            
            <motion.div className={styles.homeText} style={{opacity: opacityOut, x}}>
                
                
            <div className={styles.homeTextContainer} style={{gap: '2em'}}>
                <h3>
                    We take care of your project end-to-end
                </h3>
                <div className={styles.slideImg}>
                <TbDeviceDesktop className={styles.icon}/>
                <BsPc className={styles.icon}/>
                <BsArrowRight className={styles.icon}/>
                <TbWorldWww className={styles.icon} />

                <div className={styles.slideImgExpand}>
                <BsArrowRight className={styles.icon} style={{rotate: '-45deg'}}/>
                <BsArrowRight className={styles.icon} />
                <BsArrowRight className={styles.icon} style={{rotate: '45deg'}}/>
                </div>

                <div className={styles.slideImgExpand2}>
                    <div className={styles.slideImgExpand3}>
                    <TbDeviceDesktop className={styles.icon}/>
                    <BsPc className={styles.icon}/>
                    </div>
                    <div className={styles.slideImgExpand3}>
                    <TbDeviceDesktop className={styles.icon}/>
                    <BsPc className={styles.icon}/>
                    </div>
                    <div className={styles.slideImgExpand3}>
                    <TbDeviceDesktop className={styles.icon}/>
                    <BsPc className={styles.icon}/>
                    </div>
                </div>


                </div>
                <div className={styles.smallTestimonial}>
                    <p>
                    With the fullstack web developer support, your entirely project will be made to perform well and faster.
                    </p>
                    <p>
                    This also means you won't have any headaches, we are responsible from the development phase to the deployment and maintenance of your product.
                    </p>
                    <Link to='/about'><p>More about me here!</p></Link>
                </div>
            </div>


            </motion.div>

                
            <motion.div className={`${styles.homeText} ${styles.secSlider}`} style={{opacity: opacityIn}}>

            <div className={styles.homeTextContainer}>
                <h3>
                    With us you have options!
                </h3>
                <div className={styles.stackImg}>
                    <div className={styles.mern}>
                        <span><SiMongodb  className={styles.stackIcon}/></span>
                        <span><SiExpress  className={styles.stackIcon}/></span>
                        <span><SiReact    className={styles.stackIcon}/>  </span>
                        <span><SiNodedotjs className={styles.stackIcon}/></span>
                
                    </div>
                    <div className={styles.t3}>
                        <span><SiNextdotjs  className={styles.stackIcon}/></span>
                        <span><SiPostgresql className={styles.stackIcon}/> </span>
                        <span><SiPrisma     className={styles.stackIcon}/></span>
                        <span><RiDrizzleLine className={styles.stackIcon}/> </span>
                    </div>
                </div>
                
                <div className={styles.smallTestimonial}>
                    <p>
                    As a full stack developer, i can work on your project from different angles, offering different options that can be adapted to your budget and project requirements.
                    </p>
                  
                    <p>
                    Your project will always be developed with a focus on achieving the best performance and security for end users.
                    </p>

                    <Link to='/docs'> 
                    <p>
                        See the recomndations here!
                    </p> 
                    </Link>
                  
                </div>
            </div>
            </motion.div>

                <div className={styles.homeCenter}>
                    <motion.div className={styles.homeContainer} style={{opacity: opacityOut}}>
                        <img src="./images/pc1.png" alt="..." />
                    </motion.div>

                    <motion.div className={`${styles.homeContainer} ${styles.img2}`} style ={{opacity: opacityIn}}>
                        <img src="./images/network.jpg" alt="..." />
                    </motion.div>

                </div>
            </div>
        </div>
    </div>
  )
}

export default HomeSlider